module.exports = __webpack_public_path__ + "img/icon-powerdrops.58626362.svg";